import { GridChartCustomAttributes } from '../config/grid-chart-custom-attributes.interface';

export class GridChartUtil {
	public static reconcileAttributes(customAttributes: GridChartCustomAttributes): GridChartCustomAttributes {
		const attr = customAttributes;
		if (attr.maximumNumberOfRow) {
			if (attr.maximumNumberOfRow < Math.ceil(attr.numberOfNode / attr.nodesPerRow)) {
				// automatic make grid fading when the number of rows exceed the maximum displaying
				attr.fade = true;
				if (!attr.fadeStart) { attr.fadeStart = attr.maximumNumberOfRow - 4; }
			}
			// get rid of non-displaying nodes
			attr.numberOfNode = Math.min(attr.numberOfNode, attr.maximumNumberOfRow * attr.nodesPerRow);
		}
		return attr;
		// auto width and height base on what is displaying
	}

	public static recalculateHeight(customAttributes: GridChartCustomAttributes): number {
		return (customAttributes.nodeSize + customAttributes.spaceBetweenNode) * this.getNumberOfRow(customAttributes);
	}

	public static recalculateWidth(customAttributes: GridChartCustomAttributes): number {
		return (customAttributes.nodeSize + customAttributes.spaceBetweenNode) * customAttributes.nodesPerRow;
	}

	public static getColorByRow(currentRow: number, customAttributes: GridChartCustomAttributes): any {
		// get gradient color
		const attr = customAttributes;

		if (this.getNumberOfRow(attr) === currentRow && attr.fade && currentRow > attr.fadeStart) {
			// last row, make the grid fade to white
			const gradient = {
				linearGradient: [0, (currentRow - 1) * (attr.nodeSize + attr.spaceBetweenNode), 0, (currentRow - 1) * (attr.nodeSize + attr.spaceBetweenNode) + attr.nodeSize],
				stops: [
					[
						0,
						'rgb(' +
						this.calculateGradientColor(attr.redColor, currentRow, attr) +
						', ' +
						this.calculateGradientColor(attr.greenColor, currentRow, attr) +
						', ' +
						this.calculateGradientColor(attr.blueColor, currentRow, attr) +
						')'
					],
					[1, 'rgb(255,255,255)']
				]
			};
			return gradient;
		}
		return (
			'rgb(' +
			this.calculateGradientColor(attr.redColor, currentRow, attr) +
			', ' +
			this.calculateGradientColor(attr.greenColor, currentRow, attr) +
			', ' +
			this.calculateGradientColor(attr.blueColor, currentRow, attr) +
			')'
		);
	}
	private static calculateGradientColor(color: number, currentRow: number, customAttributes: GridChartCustomAttributes): number {
		// generate color of red, green, blue
		const attr = customAttributes;
		if (attr.fade) {
			if (!attr.fadeStart) {
				attr.fadeStart = Math.ceil(this.getNumberOfRow(attr) / 2);
			}
			if (currentRow >= attr.fadeStart) {
				return Math.round(color + (255 - color) / (this.getNumberOfRow(attr) - attr.fadeStart + 1) * (currentRow - attr.fadeStart));
			}
		}
		return color;
	}

	private static getNumberOfRow(customAttributes: GridChartCustomAttributes): number {
		const attr = customAttributes;
		return attr.maximumNumberOfRow ? Math.min(attr.maximumNumberOfRow, Math.ceil(attr.numberOfNode / attr.nodesPerRow)) : Math.ceil(attr.numberOfNode / attr.nodesPerRow);
	}
}
